export default "__VITE_ASSET__CfCuFjVk__"